import axios from 'axios';
import config from '../config';

export const updateActivationSticksBundleVersion = (deviceId: string, systemVersion: string) => {
    const data = {
        oscarConfiguration: systemVersion,
    };

    return axios
        .put(`${config.API_URL}/onboard-devices/${deviceId}/sticks/bundle`, data)
        .then((response: any) => {
            return response.data;
        });
};
